export default "ecdf1d58c0932a77.ttf"